@if (crumbs$ | async; as crumbs) {
  <nav [attr.aria-label]="'common.breadcrumbs' | cxTranslate" tabindex="-1">
    <ol [attr.aria-label]="'common.breadcrumbs' | cxTranslate">
      @for (crumb of crumbs; track crumb; let index = $index) {
        @if (index < crumbs.length - 1) {
          <li>
            <a
              [attr.aria-label]="'navigation.navigateTo' | cxTranslate : { nav: crumb.label }"
              [routerLink]="getRouterLink(crumb.link || crumb?.url)"
              [queryParams]="getQueryParams(crumb.link || crumb?.url)"
              [innerHTML]="crumb.label || (crumb?.name?.includes('common') ? (crumb?.name | cxTranslate) : crumb?.name)"
            ></a>
          </li>
        }
      }
    </ol>
  </nav>
  @if (crumbs.length) {
    <h1>
      {{
      crumbs[crumbs.length - 1]?.label ||
      (crumbs[crumbs.length - 1]?.name?.includes('common')
      ? (crumbs[crumbs.length - 1]?.name | cxTranslate)
      : crumbs[crumbs.length - 1]?.name)
      }}
    </h1>
  }
}
